export default "<p>nurse-point-sale-payment-method works!</p>\n"